// PDF 미리보기 layout 관련 상수(A4 기준)
const PAGE_UI_CONFIG = {
  width: 595,
  height: 595 * 1.414,
  columnPaddingTop: 12,
  columnHeight: 630,
  questionItemGap: 16,
  paddingBottom: 58,
};

const CHOICE_NUMBER_TEXT: Record<string, string> = {
  '1': '①',
  '2': '②',
  '3': '③',
  '4': '④',
  '5': '⑤',
};

export { CHOICE_NUMBER_TEXT, PAGE_UI_CONFIG };
